import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { TextInputWUT } from "../../inputs/text-input-wut/text-input-wut.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
const TextInputFieldWUT = ({
  id,
  target,
  label,
  hideLabel = false,
  placeholder,
  required = false,
  description,
  value = "",
  onChange,
  onBlur,
  onFocus,
  error,
  hasError = false,
  errorMessage,
  type = "text",
  disabled = false,
  readOnly,
  prefix,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  showPasswordTooltipText,
  hidePasswordTooltipText,
  widgetHtml,
  widgetEnabled,
  media,
  mediaSettings
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement,
          media,
          mediaSettings
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        TextInputWUT,
        {
          label,
          placeholder,
          required,
          value,
          onChange,
          onBlur,
          onFocus,
          type,
          disabled,
          readOnly,
          prefix,
          inputId,
          ariaDescribedBy,
          hasError,
          fieldId: id,
          showPasswordTooltipText,
          hidePasswordTooltipText
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  TextInputFieldWUT
};
//# sourceMappingURL=text-input-field-wut.js.map
